(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zura-reading-question"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input', function (event) {
    const field = event.target;
    if (field.matches('[data-zura-question]')) {
      field.setCustomValidity(field.value.trim() ? '' : field.dataset.requiredMessage);
    }
  });
  document.addEventListener('submit', function (event) {
    const field = event.target.querySelector('[data-zura-question]');
    if (!field) return;
    field.setCustomValidity(field.value.trim() ? '' : field.dataset.requiredMessage);
    if (!field.reportValidity()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      field.focus();
    }
  }, true);
  } catch(e) { console.error(e); }
})();

})();
